import React, { useLayoutEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import Footer from './pages/Footer/Footer'
import ProductCard from './components/ProductCard'
import { products } from './utils/products'
import Header from './components/Header'

function Main() {
    const [size,setSize] = useState([]);
    useLayoutEffect(() => {
        function updateSize() {
          setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
      }, []);
  return (
    <div className='main_app_div'>
      <Header subtitle="Discover tools that power sustainability action" />

      <main className='home-content'>
        <Container>
          <Row className='g-4'>
            {products.map((p) => (
              <Col key={p.id} xs="12" sm="6" lg="4">
                <ProductCard
                  title={p.title}
                  description={p.description}
                  icon={p.icon}
                  link={p.link}
                  to={p.to}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </main>

      <Footer />
    </div>
  )
}

export default Main